import { render, staticRenderFns } from "./selectSupplier.vue?vue&type=template&id=5a4853a5&scoped=true&"
import script from "./selectSupplier.vue?vue&type=script&lang=js&"
export * from "./selectSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4853a5",
  null
  
)

export default component.exports